import {Section} from '../../../api/models';
import {FormComponent} from './FormComponent';

interface ComponentResolverProps {
    section: Section;
    websiteId: string;
    throwSnackbarMessage: (message: string) => void;
    refetch: VoidFunction;
}

export const ComponentResolver = ({section, websiteId, throwSnackbarMessage, refetch}: ComponentResolverProps) => {
    if (section) {
        return (
            <div>
                <div key={section.id}>
                    <FormComponent
                        data={section}
                        websiteId={websiteId}
                        throwSnackbarMessage={throwSnackbarMessage}
                        refetch={refetch}
                    />
                </div>
                <br />
            </div>
        );
    } else {
    }
};
